import { ReorderIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";
import styles from "./EditCustomPlanButton.module.scss";

interface ReorderMeasuresModalProps {
    setReorderModalIsOpen: () => void;
}
function ReorderMeasuresButton({ setReorderModalIsOpen }: ReorderMeasuresModalProps) {
    return (
        <button className={styles.addProjectButton} type="button" onClick={setReorderModalIsOpen}>
            <ReorderIcon height={15} />
            <Paragraph>Reorder Measures</Paragraph>
        </button>
    );
}

export default ReorderMeasuresButton;
